import { CatalogBaseModel } from './CatalogBaseModel';

export class CatalogProjectActivity extends CatalogBaseModel {
  static get entity() {
    return 'catalog-project-activities';
  }

  static fields() {
    return {
      id: this.uid()
    };
  }

  static apiConfig = {
    actions: {
      /**
       * Log the first "viewed" activity for the current user's project(s) containing this
       * micro-credential. Only recorded once per project, and only while the project is within
       * its started/ended dates.
       *
       * Calls POST /v1/projects/log-view
       *
       * @param {number} learningUnitId
       */
      async logProjectView(learningUnitId) {
        return this.post('/v1/projects/log-view', { learning_unit_id: learningUnitId }, { save: false });
      },

      /**
       * Log the first "viewed" activity for this micro-credential, provided it belongs to one of
       * the current user's projects and that project is within its started/ended dates.
       *
       * Calls POST /v1/learning-units/log-view
       *
       * @param {number} learningUnitId
       */
      async logLearningUnitView(learningUnitId) {
        return this.post('/v1/learning-units/log-view', { learning_unit_id: learningUnitId }, { save: false });
      }
    }
  };
}

export default CatalogProjectActivity;
